import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '../../../../../../components/Common/UI/Input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../../../components/Common/UI/Select';
import Separator from '../../../../../../components/Common/UI/Separator';
import { Button } from '../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { AccountManagementRes } from '../../columns';
import { InvalidFields } from '../index';

interface ICreateAccountForm {
  state: AccountManagementRes;
  invalidFields: InvalidFields;
  handleInputChange: (key: keyof AccountManagementRes, value: string) => void;
  handleValidate: (key: keyof AccountManagementRes, value: string) => void;
  handleSelectChange: (value: string) => void;
  handleReset: () => void;
  handleSubmit: () => void;
}

export enum CreateAccountTypeEnum {
  'selectOne' = 'Select One',
  'unknown' = 'Unknown',
  'depositAccount' = 'Deposit Account',
  'BMSStatement' = 'BMS Statement',
  'accountAnalysis' = 'Account Analysis',
  'declineLetter' = 'Decline Letter',
  'loanAccount' = 'Loan Account',
  'ira' = 'Certificate Of Deposits IR - IRA',
}

export const createAccountType: { key: keyof typeof CreateAccountTypeEnum; label: string }[] = [
  { key: 'selectOne', label: CreateAccountTypeEnum.selectOne },
  { key: 'unknown', label: CreateAccountTypeEnum.unknown },
  { key: 'depositAccount', label: CreateAccountTypeEnum.depositAccount },
  { key: 'BMSStatement', label: CreateAccountTypeEnum.BMSStatement },
  { key: 'accountAnalysis', label: CreateAccountTypeEnum.accountAnalysis },
  { key: 'declineLetter', label: CreateAccountTypeEnum.declineLetter },
  { key: 'loanAccount', label: CreateAccountTypeEnum.loanAccount },
  { key: 'ira', label: CreateAccountTypeEnum.ira },
];

function CreateAccountForm({
  handleSubmit,
  handleReset,
  handleValidate,
  invalidFields,
  state,
  handleSelectChange,
  handleInputChange,
}: ICreateAccountForm) {
  const navigate = useNavigate();

  return (
    <>
      <div className="grid gap-[20px]">
        <Input
          placeholder="Enter Account Number"
          label="Account Number"
          error={invalidFields.accountNumber ? 'Account Number Cannot Be Blank' : null}
          onChange={e => handleInputChange('accountNumber', e.target.value)}
          onBlur={e => handleValidate('accountNumber', e.target.value)}
          value={state?.accountNumber}
          maxLength={75}
        />
        <Input
          placeholder="Enter Accound Name"
          label="Account Name"
          error={invalidFields.accountName ? 'Account Name Cannot Be Blank' : null}
          onChange={e => handleInputChange('accountName', e.target.value)}
          onBlur={e => handleValidate('accountName', e.target.value)}
          value={state?.accountName}
          maxLength={75}
        />
        <Select onValueChange={e => handleSelectChange(e)} value={state.accountType}>
          <SelectTrigger className="w-[630px]" label="Search Type">
            <SelectValue placeholder="Select One" />
          </SelectTrigger>
          <SelectContent>
            {createAccountType.map(({ key, label }) => (
              <SelectItem key={key} value={key}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <Separator className="mt-[20px]" />
      <div className="flex justify-between items-center gap-[20px] py-[10px]">
        <Button
          variant="link"
          onClick={() => navigate('/infoTrac/account-management')}
          className="flex gap-[10px] items-center px-0"
        >
          <Icons.ArrowRight className="rotate-180" />
          Back
        </Button>
        <div className="flex gap-[20px] items-center">
          <Button variant="secondary" onClick={handleReset}>
            Reset
          </Button>
          <Button onClick={handleSubmit} className="flex gap-[10px] items-center">
            <Icons.SaveFilled className="opacity-60 w-[20px] h-[20px]" />
            Save
          </Button>
        </div>
      </div>
    </>
  );
}

export default CreateAccountForm;
